
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component
export default class RigInfo extends Vue {
    
    start = new Date()
    end = new Date()

    onStartDateChanged(){
        this.$store.commit('setDynamicStart',this.start)
    }

    onEndDateChanged(){
        this.$store.commit('setDynamicEnd',this.end)
    }

    get dynamicStart(){
        return this.$store.getters['getDynamicStartDate']
    }

    get dynamicEnd(){
        return this.$store.getters['getDynamicEndDate']
    }

    @Watch("dynamicStart",{immediate:true})
    onDynamicStartChanged(){
        this.start = this.dynamicStart
    }

    @Watch("dynamicEnd",{immediate:true})
    onDynamicEndChanged(){
        this.end = this.dynamicEnd
    }
}
